import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { Button, InlineError, PageRouteScaffold, StatusPage } from '@wapharma/design-system';

export function AdminRouteError() {
  const err = useRouteError();
  const message = isRouteErrorResponse(err)
    ? `${err.status} ${err.statusText}`
    : err instanceof Error
      ? err.message
      : 'Erreur inattendue';
  const isNotFound = isRouteErrorResponse(err) && err.status === 404;

  return (
    <PageRouteScaffold>
      <StatusPage
        variant={isNotFound ? 'not-found' : 'warning'}
        title={isNotFound ? 'Page introuvable' : 'Page indisponible'}
        description={<InlineError title="Détail">{message}</InlineError>}
        illustrationSize="lg"
      >
        <Button as={Link} to="/" variant="soft">
          Retour à l&apos;accueil
        </Button>
      </StatusPage>
    </PageRouteScaffold>
  );
}
